<div class="maintenance-page-container">
  <mat-card>
    <mat-card-content>
      <div *ngIf="canAccessMaintenancePage" class="maintenance-page-link">
        <a mat-button color="primary" routerLink="/quest/global/maintenance"
          >Go to Maintenance Page</a
        >
      </div>
      <div class="icon-container">
        <mat-icon class="maintenance-icon">build</mat-icon>
      </div>

      <div class="content-container">
        <div>
          <h1 class="title">Under Maintenance</h1>
          <h2 class="sub-title">We're currently performing scheduled maintenance</h2>
          <p class="description">
            {{ maintenanceMessage }}
          </p>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
